/*global google*/
import React, { useState, useEffect } from "react";
import GoogleMapReact from "google-map-react";

import moment from "moment";

//ui
import { Switch } from "antd";
import DropDownMenu from "../../components/DropDownMenu";
//utils
import { get } from "../../utils/utils";
import { computeCenterAndZoomOfListOfGps, UPSELL_GPS } from "../../utils/map.utils";
import { TRIP_TYPE_ID } from "../../../../configs/constants";
import { displayFromMinutesDuration } from "../../utils/date.utils";
import Marker from "../../components/Marker";

let tripPath;
let map;
let maps;
const TOKEN = "AIzaSyDxkSpxLuz_dGanirSXNDuvA_6pDDPJafo";

const addTripPath = markers => {
  const lineSymbol = {
    path: maps.SymbolPath.FORWARD_CLOSED_ARROW
  };
  tripPath = new maps.Polyline({
    path: markers,
    geodesic: true,
    strokeColor: "#FF0000",
    strokeOpacity: 1.0,
    strokeWeight: 2,
    icons: [{ icon: lineSymbol, offset: "100%" }]
  });
  tripPath.setMap(map);
};
export default function MapModal({ data, modifyTrip }) {
  const markers = Array.isArray(data.path)
    ? data.path.map(point => ({ ...point, lat: point.lat || UPSELL_GPS.lat, lng: point.long || UPSELL_GPS.lng }))
    : [];
  const startLocation = get([0, "label"], markers, "N/C");
  const endLocation = get([markers.length - 1, "label"], markers, "N/C");
  const defaultZoom = 6;
  const defaultLat = get([0, "lat"], markers, UPSELL_GPS.lat);
  const defaultLng = get([0, "lng"], markers, UPSELL_GPS.lng);
  const centerDefault = { lat: defaultLat, lng: defaultLng };
  const [activity, setActivity] = useState();
  const [isProTrip, setIsProTrip] = useState(data.type === "trajetPro");
  const [centerAndZoom, setCenterAndZoom] = useState(computeCenterAndZoomOfListOfGps(markers));
  const [modified, setModified] = useState(false);

  useEffect(() => {
    setIsProTrip(data.type === "trajetPro");
    setModified(false);
    setCenterAndZoom(computeCenterAndZoomOfListOfGps(markers));
    if (map && maps) {
      tripPath.setMap(null);
      addTripPath(markers);
    }
  }, [data.id]);

  return (
    <div>
      <div className={"flex"}>
        <div className={"w-2/5"}>
          <GoogleMapReact
            bootstrapURLKeys={{ key: TOKEN }}
            defaultCenter={centerDefault}
            defaultZoom={defaultZoom}
            center={centerAndZoom.center}
            zoom={centerAndZoom.zoom}
            yesIWantToUseGoogleMapApiInternals
            onGoogleApiLoaded={({ map: _map, maps: _maps }) => {
              map = _map;
              maps = _maps;
              tripPath = new maps.Polyline();
              tripPath.setMap(null);
              addTripPath(markers);
            }}
          >
            {markers.map((marker, i) => (
              <Marker key={i} lng={marker.lng} lat={marker.lat} />
            ))}
          </GoogleMapReact>
        </div>
        <div className={"w-3/5 px-5"}>
          <div className="mb-12">
            <span className="font-bold text-xl mr-2">Perso</span>
            <Switch
              defaultChecked={isProTrip}
              checked={isProTrip}
              onChange={checked => {
                setIsProTrip(checked);
                setModified(true);
              }}
            />
            <span className="font-bold text-xl ml-2">Pro</span>
          </div>
          <div className="my-4">
            <span className="font-bold">Distance : </span>
            <span className="">{data.distance + "km"}</span>
          </div>
          <div className="my-4">
            <span className="font-bold">Heure départ : </span>
            <span className="">{moment(data.start_date).format("HH[h]mm")}</span>
          </div>
          <div className="my-4">
            <span className="font-bold">Lieu de départ : </span>
            <span className="">{startLocation}</span>
          </div>
          <div className="my-4">
            <span className="font-bold">Heure d'arrivée : </span>
            <span className="">{moment(data.end_date).format("HH[h]mm")}</span>
          </div>
          <div className="my-4">
            <span className="font-bold">Lieu d'arrivée : </span>
            <span className="">{endLocation}</span>
          </div>
          <div className="my-4">
            <span className="font-bold">Durée : </span>
            <span className="">{displayFromMinutesDuration(data.start_date, data.end_date)}</span>
          </div>
          {isProTrip && (
            <div className="my-6 flex align-middle">
              <span className="font-bold py-3 mr-3">Evenement : </span>
              <DropDownMenu
                title={"Selectionner"}
                optionSelected={option => {
                  const act = data.activities.find(activity => activity.pdc_label === option);
                  setActivity(act._id);
                  setModified(true);
                }}
                options={data.activities.map(activity => activity.pdc_label)}
              />
            </div>
          )}
        </div>
      </div>
      <div className="mx-auto w-full mt-5">
        <div
          className="cursor-pointer px-6 py-2 mx-2 leading-5 rounded-full bg-green-500 text-white w-32 text-center mx-auto"
          onClick={() => {
            modifyTrip({
              id: data.id,
              type: { id: isProTrip ? TRIP_TYPE_ID.PRO : TRIP_TYPE_ID.PERSO },
              visit: { _id: activity },
              index: data.index
            });
          }}
        >
          {modified ? "Modifier" : "Ok"}
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// src/modules/presence/presence/modals/mapModal.js